<template>
  <div class="mt-80">
    <div class=" about-page">
      <div class="about-page-header">
        <img src="@/assets/photo.png" alt="" class="photo">
        <div>
          <h1 class="mt-0 mb-1">Светлана Рамбелли</h1>
          <h2 class="mb-5">Практикующий психолог</h2>
          <p class="info-label mt-0">Телефон:</p>
          <p class="about-info mt-0">Viber: <span class="numbers" style="font-weight: 400"><u><span class="Raleway">+</span>393200946598</u></span></p>
          <p class="about-info mt-0">WhatsApp: <span class="numbers" style="font-weight: 400"><u><span class="Raleway">+</span>393200946598</u></span></p>
          <p class="info-label mt-0">Email:</p>
          <p class="about-info mt-0">svetlanarambelli@gmail.com</p>
        </div>
      </div>
      <div class="about-text">
        <ThreeDots class="dots"/>
        <h1 class="title">Обо мне</h1>
        <p class="about-text-text mb-0 mt-4">Здравствуйте. Я Светлана Рамбелли, практикующий психолог, лауреат международных конкурсов, экспертный рецензент книги «Разреши себе жить», автор youtube канала, счастливая жена и мать. Приглашаю вас на мои консультации по скайпу или по переписке. </p>
        <p class="about-text-text mb-0 mt-4">На индивидуальных консультациях мои клиенты преодолевают страх завершения задуманного, прорабатывают чувство вины и токсического стыда, возвращают ответственность окружающим за их чувства и претензии. Вы можете получить профессиональную поддержку в период кризиса, найти ресурсы в обидах и пережитых психологических травмах, освоить желательные навыки вместо борьбы с плохими привычками, открыть точки роста в слабостях и болезненных воспоминаниях. Я поддержу вас в поиске наилучшего выбора из всех возможных вариантов, помогу улучшить отношения с близкими. В результате психологической работы вы можете заметить, что вам стало проще отстаивать свои границы, общаться с родственниками и коллегами. Ваша интимная жизнь может стать ярче или вы, наконец, решитесь на разрыв токсичных отношений. Мы будем совместно работать над постановкой ваших целей, ориентируясь на достижение результата. </p>
        <p class="about-text-text mb-0 mt-4">Ответственность за итоги совместной работы мы делим поровну. Со своей стороны я постараюсь сделать всё возможное для эффективного сотрудничества, используя понимание и профессионализм. При этом я проявляю уважение к вашему текущему состоянию и оставляю за вами выбор – интенсивно двигаться к изменениям или поддерживать своё ощущение стабильности.</p>
        <p class="about-text-text mb-0 mt-4">Я использую самые действенные и максимально подходящие для каждого конкретного случая инструменты работы из <strong>следующих направлений:</strong></p>
        <p class="about-text-text mb-0 mt-2"><dot class="mr-2"/> Трансактный анализ</p>
        <p class="about-text-text mb-0 mt-2"><dot class="mr-2"/> Клиент-центрированная терапия</p>
        <p class="about-text-text mb-0 mt-2"><dot class="mr-2"/> Гештальт-терапия.</p>
        <p class="about-text-text mb-0 mt-4">Моё образование:</p>
        <p class="about-text-text mb-0 mt-2"><dot class="mr-2"/> Московский институт психоанализа. Профиль: психологическое консультирование и диагностика личности.</p>
        <p class="about-text-text mb-0 mt-2"><dot class="mr-2"/> Волгоградская гуманитарная академия. Квалификация: семейный психолог.</p>
        <p class="about-text-text mb-0 mt-2"><dot class="mr-2"/> Высшая школа "Среда обучения": курс "Учимся принимать себя".</p>
        <p class="about-text-text  mb-0 mt-2"><dot class="mr-2"/> Италия, Болонья, "Центр благополучия и здоровья".</p>
        <p class="about-text-text mb-0 mt-4">До получения диплома психолога в Московском институте психоанализа я работала начальником отдела снабжения в центральном офисе крупной компании. Большой опыт сотрудничества с владельцами бизнеса и тренинги по ведению переговоров научили меня балансировать между жестким отстаиванием своих интересов и чутким отношением к окружающим. Благодаря разностороннему опыту я смотрю на ситуации гибко и системно. Сама я, благодаря личной терапии и квалификации психолога, смогла объединить мой жизненный опыт, и все полученные знания направляю на оказание качественной психологической поддержки клиентам. </p>
        <p class="about-text-text mb-0 mt-4">Дополнительно к индивидуальному психологическому консультированию я освоила квалификацию семейного психолога, благодаря чему могу системно подходить к улучшению детско-родительских отношений и разрешению кризисов в отношениях. Я регулярно развиваю свой профессионализм на тренингах и участвую в интервизии. Также я продолжаю проходить личную терапию и супервизию, что обеспечивает надежное и безопасное пространство консультации, свободное от проекций психолога, где время принадлежит только клиенту.</p>
      </div>
      <button class="button mt-5" @click="$router.push('/services')">Записаться <under-arrow/></button>
    </div>
    <Videos/>
    <Footer/>
  </div>
</template>

<script>
  import Footer from '@/views/Home/components/Footer';
  import UnderArrow from '@/components/icons/UnderArrow';
  import ThreeDots from '@/components/icons/ThreeDots';
  import Dot from '@/components/icons/Dot';
  import Videos from '@/views/Home/components/Videos';
  export default {
    metaInfo: {
      title: 'Обо мне'
    },
    name: "About",
    components: { UnderArrow, Footer, Videos, ThreeDots, Dot}
  }
</script>

<style lang="scss">
  .about-page {
    padding: 80px 220px;
    max-width: 1400px;
    margin-left: auto;
    margin-right: auto;
    font-family: 'Raleway', sans-serif;
    &-header {
      display: flex;
      justify-content: center;
      align-items: center;
      margin-bottom: 64px;
      .photo {
        max-width: 422px;
        margin-right: 115px;
      }
      h1 {
        font-size: 32px;
        font-weight: 600;
        color: #1f1f1f;
      }
      h2 {
        font-size: 20px;
        font-weight: 600;
        color: #7e7e7e;
      }
      .info-label {
        font-size: 17px;
        font-weight: 600;
        color: #1f1f1f;
      }
      .about-info {
        font-size: 17px;
        font-weight: normal;
        color: #1f1f1f;
      }
    }
    .about-text {
      font-family: 'Raleway', sans-serif;
      .title {
        margin-bottom: 64px;
      }
      &-text {
        font-size: 17px;
        line-height: 1.71;
        text-align: justify;
        color: #1f1f1f;
        strong {
          font-weight: 500;
        }
      }
    }
    .button {
      width: 247px;
      height: 75px;
      border-radius: 9px;
      background-color: #55cce7;
      margin-right: 32px;
      font-family: 'Raleway', sans-serif;
      font-size: 24px;
      font-weight: 600;
      border: none;
      position: relative;
      z-index: 3;
      color: #ffffff;
      margin-top: 24px;
      margin-left: auto;
      margin-right: auto;
      display: block;
      svg {
        transform: rotate(-90deg);
        margin-left: 15px;
      }
    }
  }
  @media screen and (max-width: 1300px){
    .about-page {
      padding: 64px;
    }
  }
  @media screen and (max-width: 1000px){
    .about-page {
      padding: 64px 32px;
    }
  }
  @media screen and (max-width: 992px){
    .about-page {
      .button {
        width: 181px;
        height: 48px;
        border-radius: 9px;
        background-color: #55cce7;
        display: flex;
        align-items: center;
        justify-content: center;
        font-size: 17px;
        font-weight: 600;
        color: #ffffff;
        margin-top: 38px !important;
        svg {
          margin-left: 20px;
          transform: rotate(-90deg);
        }
      }
      &-header {
        flex-wrap: wrap;
        .photo {
          width: 100%;
          margin-right: 0;
          margin-bottom: 64px;
        }
        div {
          width: 100%;
          text-align: center;
        }
      }
    }
  }
  @media screen and (max-width: 568px){
    .about-page {
      padding: 48px 24px;
      .title {
        margin-bottom: 32px !important;
      }
      &-header {
        flex-wrap: wrap;
        margin-bottom: 32px;
        .photo {
          width: 100%;
          margin-right: 0;
          margin-bottom: 32px;
        }
        div {
          width: 100%;
          text-align: center;
          h1 {

          }
          h2 {
            margin-bottom: 24px !important;
          }
        }
      }
    }
  }
</style>